import React, { useEffect, useState } from "react";
import {  useNavigate, useParams, useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Spinner from "../../ui/Spinner/Spinner";
import moment from "moment";

import EditMedCardForm from "../EditMedCardForm";
import Button from "../../ui/Button/Button";
import api from "../../../../api";

import { getPatientRelations } from "../../../../redux/patients/actions";
import Carousel from "../../ui/Carousel/Carousel";

const MedCard = ({
  patientCard,
  propsRole,
  getPatientRelations,
  relations,
  patientCards,
}) => {
  console.log('Debug patientCard:', patientCard);
  const [edit, setEdit] = useState(false);
  const [searchParams] = useSearchParams()
  const navigate = useNavigate();
  const params = useParams()
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    getPatientRelations();
  }, []);

  // Function to find main company from patient cards
  const getMainCompanyFromCards = () => {
    if (!patientCards || !Array.isArray(patientCards)) return "";
    
    // Find the main card (uniqueRelation === 1)
    const mainCard = patientCards.find(card => 
      card.relationShip && card.relationShip.uniqueRelation === 1
    );

    return mainCard?.company?.title || "";
  };

  // Function to find main insurance company from patient cards
  const getMainInsuranceCompanyFromCards = () => {
    if (!patientCards || !Array.isArray(patientCards)) return "";
    
    // Find the main card (uniqueRelation === 1)
    const mainCard = patientCards.find(card => 
      card.relationShip && card.relationShip.uniqueRelation === 1
    );
    
    return mainCard?.insuranceCompanyName || "";
  };

  const getOld = (input_date) => {
    const date = new Date(input_date);
    const date_in_ms = date.getTime();

    const beauty_date = date.toLocaleDateString().replace(/\//gi, ".");
    return `${beauty_date} (${moment(date_in_ms).fromNow(true)})`;
  };

  const deleteCardHandler = (cardId) => {
    if (window.confirm(t("deleteConfirm"))) {
      api.patients.deletePatientCard(cardId)
        .then(() => navigate("/"))
        .catch(e => {
        alert(`issue with delete patient card - ${e}`)
      });
    }
  };

  const MedCardField = ({ title = "", value = "", last = false }) => {
    return (
      <div className="medcard-field">
        <div className="title">{title}</div>
        <div className="value">{value}</div>
        {!last && <div className="separator"></div>}
      </div>
    );
  };

  // Create a custom version of MedCardField specifically for the additionalInfo field
  const MedCardFieldMultiline = ({ title = "", value = "", last = false, content = "" }) => {
    // Always show the expand button for testing purposes
    const needsExpandButton = true; // content && content.length > 150;
    
    return (
      <div className="medcard-field">
        <div className="title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {title}
          {needsExpandButton && (
            <button 
              onClick={(e) => {
                e.preventDefault();
                setIsExpanded(!isExpanded);
              }} 
              style={{ 
                background: 'none', 
                border: 'none', 
                cursor: 'pointer', 
                padding: '2px 5px',
                display: 'flex',
                alignItems: 'center',
                fontSize: '11px',
                color: '#4b9bf5',
                borderRadius: '4px',
                transition: 'background-color 0.2s',
                marginLeft: '5px'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              title={isExpanded ? t("showLess") : t("showMore")}
            >
              {isExpanded ? t("showLess") : t("showMore")}
              <span style={{ 
                marginLeft: '3px',
                transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s',
                display: 'inline-block',
                fontSize: '8px'
              }}>▼</span>
            </button>
          )}
        </div>
        <div className="value" style={{ 
          height: "auto", 
          minHeight: "37px", 
          marginTop: "5px", 
          marginBottom: needsExpandButton ? (isExpanded ? "15px" : "5px") : "10px",
          transition: "max-height 0.3s ease-in-out"
        }}>
          {value}
        </div>
        {!last && <div className="separator"></div>}
      </div>
    );
  };

  const checkedRole = propsRole === "operator" || propsRole === "insurance-operator";
  const isActualCardData = patientCard?.id === Number(params.card)
  const isNoCards = (params.card === searchParams.get("user")) && !(patientCard && patientCard.id)
  
  ////NOTHING IF PATIENT HAS NO CARDS
  if (isNoCards) return null
  
  //LOADING WHEN OLD INFO EXIST
  if (!isActualCardData) {
    return (
      <div className="loadingBox">
        <Spinner/>
      </div>
    )
  }
  
  // Add function to format subscription dates and check status
  const getSubscriptionInfo = (startDate, endDate) => {
    if (!startDate || !endDate) return "";
    
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    const now = moment();

    const startFormatted = startMoment.format("DD.MM.YYYY");
    const endFormatted = endMoment.format("DD.MM.YYYY");

    let statusText;
    // Check if the start date is in the future (tomorrow or later)
    if (startMoment.isAfter(now, 'day')) {
      statusText = t("subscriptionScheduled", "Запланована");
    } 
    // Check if the end date is in the past (yesterday or earlier)
    else if (endMoment.isBefore(now, 'day')) {
      statusText = `<span style="color: red">${t("expiredSubscription", "Прострочена")}</span>`;
    } 
    // Otherwise, it's currently active
    else {
      statusText = t("subscriptionActive", "Активна");
    }

    return `${startFormatted} - ${endFormatted} (${statusText})`;
  };

  // Format subscription info from the new API field
  const formatSubscriptionInfo = (subscriptionInfo) => {
    if (!subscriptionInfo) return "";
    
    const startMoment = moment(subscriptionInfo.startAt);
    const endMoment = moment(subscriptionInfo.endAt);
    const now = moment();

    const start = startMoment.format("DD.MM.YYYY");
    const end = endMoment.format("DD.MM.YYYY");
    
    let statusText;
    if (startMoment.isAfter(now, 'day')) {
      // Start date is in the future (tomorrow or later)
      statusText = t("subscriptionScheduled", "Запланована"); 
    } else if (endMoment.isBefore(now, 'day')) {
      // End date is in the past (yesterday or earlier)
      statusText = `<span style="color: red">${t("expiredSubscription", "Прострочена")}</span>`;
    } else if (subscriptionInfo.isActive) {
      // Active and within valid date range
      statusText = t("subscriptionActive", "Активна"); 
    } else {
      // Not active for other reasons (e.g., payment issues)
      statusText = `<span style="color: red">${t("subscriptionInactive", "Неактивна")}</span>`;
    }
    
    return `${start} - ${end} (${statusText})`;
  };

  return (
    <div className="medcard-info">
      <div className="medcard-content">
        {!edit && (
          <>
            <MedCardField
              title={t("name")}
              value={patientCard.firstName ? patientCard.firstName : ""}
            />
            <MedCardField
              title={t("lastName")}
              value={patientCard.lastName ? patientCard.lastName : ""}
            />
            <MedCardField
              title={t("patronymic")}
              value={patientCard.patronymic ? patientCard.patronymic : ""}
            />
            <MedCardField
              title={t("birthDate")}
              value={patientCard.birthDate ? getOld(patientCard.birthDate) : ""}
            />
            <MedCardField
              title={t("sex")}
              value={
                (patientCard && patientCard.gender === 0 && t("maleSex")) ||
                (patientCard && patientCard.gender === 1 && t("femaleSex")) ||
                ""
              }
            />
            <MedCardField
              title={t("relations")}
              value={patientCard.relationShip && patientCard.relationShip.title}
            />
            <MedCardField
              title={t("insuranceCompanyName")}
              value={getMainCompanyFromCards()}
            />
            <MedCardField
              title={t("insuranceCompany")}
              value={getMainInsuranceCompanyFromCards()}
            />
            <MedCardField
              title={t("policeNumber")}
              value={patientCard.policeNumber}
            />

            {patientCard?.relationShip?.uniqueRelation === 1 && (
              <MedCardField
                title={t("insuranceSubscriptionPeriod")}
                value={
                  <div dangerouslySetInnerHTML={{
                    __html: getSubscriptionInfo(
                      patientCard?.patient?.companySubscriptionBookedAt,
                      patientCard?.patient?.companySubscriptionExpiredAt
                    )
                  }} />
                }
              />
            )}

            {/* Display subscription info if available */}
            {(propsRole === "doctor" || propsRole === "operator" || propsRole === "insurance-operator") && 
              patientCard?.subscriptionInfo && (
              <>
                <MedCardField
                  title={t("subscriptionTitle")}
                  value={patientCard.subscriptionInfo.title || ""}
                />
                <MedCardField
                  title={t("subscriptionPeriod")}
                  value={
                    <div dangerouslySetInnerHTML={{
                      __html: formatSubscriptionInfo(patientCard.subscriptionInfo)
                    }} />
                  }
                />
              </>
            )}

            <MedCardField title={t("email")} value={patientCard.email} />
            <MedCardField
              title={t("phoneNumber")}
              value={patientCard.phone}
            />
            {(propsRole === "doctor" || propsRole === "operator" || propsRole === "insurance-operator") && (
              <MedCardFieldMultiline
                title={t("additionalInfo")}
                content={patientCard.additionalInfo || ""}
                value={
                  <div style={{ 
                    maxHeight: isExpanded ? "none" : "100px", 
                    overflowY: isExpanded ? "visible" : "auto",
                    wordWrap: "break-word", 
                    whiteSpace: "pre-wrap",
                    paddingRight: "5px"
                  }}>
                    {patientCard.additionalInfo || ""}
                  </div>
                }
                last
              />
            )}
            {!(propsRole === "doctor" || propsRole === "operator" || propsRole === "insurance-operator") && (
              <div className="separator"></div>
            )}
          </>
        )}
        {edit && (
          <EditMedCardForm
            setEdit={setEdit}
            patientCard={patientCard}
            relations={relations}
            propsRole={propsRole}
          />
        )}
      </div>

      {!edit && checkedRole && (
        <div className="medcard-footer">
          <Button
            text={t("editButton")}
            freeTopSpace
            className="btn editCardButton"
            type="button"
            onClick={() => setEdit(true)}
          />
          <Button
            text={t("deleteButton")}
            className="btn deleteCardButton"
            type="button"
            danger
            onClick={() => {
              deleteCardHandler(patientCard.id);
            }}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  patientCard: state?.patients?.patient,
  relations: state.patients && state.patients.relations,
  patients: state.patients,
  patientCards: state.patients && state.patients.cards && state.patients.cards.items,
});

const mapDispatchToProps = { getPatientRelations };

export default connect(mapStateToProps, mapDispatchToProps)(MedCard);
